import React from 'react';
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';

import { rateImportApi } from '@/main/api';
import { useBodyshopRateContext } from '../bodyshopRateContext';
import { RateImportPaginationRequest } from '@/main/models/request';
import RowBodyshopRate from './rowBodyshopRate/rowBodyshopRate';
import * as S from './styles';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { getTranslateByKey } from '@/main/services/utils';

function BodyshopRateGrid() {
  const { dataGrid, formFilters, setDataGrid } = useBodyshopRateContext();

  const rowsHeader = [
    getTranslateByKey('information.filename'),
    getTranslateByKey('information.insurer'),
    `${getTranslateByKey('information.userName')} / ${getTranslateByKey('information.dateTime')}`,
    getTranslateByKey('information.status'),
    <S.TextCenter key="actions">
      {getTranslateByKey('information.actions')}
    </S.TextCenter>
  ];

  async function fetchData(request: RateImportPaginationRequest) {
    return rateImportApi
      .getSearchGrid(request)
      .then((response: any) => response.data);
  }

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        fetchMore={fetchData}>
        <BoxGrid rowHeaders={rowsHeader}>
          {dataGrid.map((item) => (
            <RowBodyshopRate
              key={item.guidFileImport}
              rate={item}
            />
          ))}
        </BoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  );
}

export default BodyshopRateGrid;
